import {
  Drawer,
  Typography,
  Switch,
  TimePicker,
  Divider,
  Button,
  Modal,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import {
  EditOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import EditSchedule from "./EditSchedule";
import SetBrokenTime from "./SetBrokenTime";

const SetSchedule = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const [employeeSchedule, setEmployeeSchedule] = useState({
    data: [],
    ready: false,
  });
  const [dataSets, setDataSets] = useState([
    { id: 1, is_active: false, day: "Monday", timein: "", timeout: "" },
    { id: 2, is_active: false, day: "Tuesday", timein: "", timeout: "" },
    { id: 3, is_active: false, day: "Wednesday", timein: "", timeout: "" },
    { id: 4, is_active: false, day: "Thursday", timein: "", timeout: "" },
    { id: 5, is_active: false, day: "Friday", timein: "", timeout: "" },
    { id: 6, is_active: false, day: "Saturday", timein: "", timeout: "" },
    { id: 7, is_active: false, day: "Sunday", timein: "", timeout: "" },
  ]);
  const [detectIfEmpty, setDetectIfEmpty] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [openEditSched, setOpenEditSched] = useState(false);
  const [openBrokenTime, setOpenBrokenTime] = useState(false);
  const [specificData, setSpecificData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const getEmployeeSchedule = useCallback(() => {
    var params = { user_id: selectedData.user_id };
    axios
      .get("user/merchant/get/employee-schedule", { params })
      .then((response) => {
        const data = response.data;
        // console.log("DATA: ", data);
        setEmployeeSchedule({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData.user_id]);

  useEffect(() => {
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-sub-category"
    ) && getEmployeeSchedule();
  }, [getEmployeeSchedule]);

  const updateStatusByID = (id, newValue, oldArray) => {
    // console.log("NEW VALUE: ", newValue);
    var array = [...oldArray];
    const updatedItem = oldArray.find((item) => item.id === id);
    if (!newValue) {
      updatedItem.timein = "";
      updatedItem.timeout = "";
    }
    updatedItem.is_active = newValue;

    for (let i = 0; i < array.length; i++) {
      if (array[i].is_active) {
        if (array[i].timein === "") {
          setDetectIfEmpty(false);
        } else if (array[i].timeout === "") {
          setDetectIfEmpty(false);
        } else {
          setDetectIfEmpty(true);
        }
      }
    }

    return array;
  };

  const updateDateByID = (id, newValue, oldArray, method) => {
    var array = [...oldArray];
    const updatedItem = oldArray.find((item) => item.id === id);
    if (method === "out") {
      updatedItem.timeout = newValue;
    } else {
      updatedItem.timein = newValue;
    }
    for (let i = 0; i < array.length; i++) {
      if (array[i].is_active) {
        if (array[i].timein === "") {
          setDetectIfEmpty(false);
        } else if (array[i].timeout === "") {
          setDetectIfEmpty(false);
        } else {
          setDetectIfEmpty(true);
        }
      }
    }
    return array;
  };

  const handleCreateEmployeeSchedule = () => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    formdata.append("merchant_id", userData.data.id);
    formdata.append("schedule_length", dataSets.length);

    for (let i = 0; i < dataSets.length; i++) {
      formdata.append("schedule_day[]", dataSets[i].day);
      formdata.append("schedule_status[]", dataSets[i].is_active ? 1 : 0);
      formdata.append("start_datetime[]", dataSets[i].timein);
      formdata.append("end_datetime[]", dataSets[i].timeout);
    }

    axios
      .post("user/merchant/create/employee-schedule", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Schedule created successfully");
          setTimeout(() => {
            getEmployeeSchedule();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteBrokeTime();
    }, 2000);
  };

  const handleDeleteBrokeTime = () => {
    const formdata = new FormData();
    formdata.append("id", specificData !== null ? specificData.id : "");
    formdata.append("mes_id", specificData !== null ? specificData.mes_id : "");
    axios
      .post("user/merchant/delete/broken-time", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete broken time successfully.");
          setTimeout(() => {
            getEmployeeSchedule();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Drawer
      title={
        employeeSchedule.ready && employeeSchedule.data.length > 0
          ? "Schedule List"
          : "Set Schedule"
      }
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      width={window.innerWidth > 600 ? 600 : "100vw"}
    >
      {employeeSchedule.ready && employeeSchedule.data.length > 0 ? (
        <>
          {employeeSchedule.data.map((item, key) => (
            <div key={key}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 80 }}>
                  <Typography>{item.schedule_day}</Typography>
                </div>
                <Switch
                  checked={Boolean(parseInt(item.schedule_status))}
                  size="small"
                  disabled
                />
                <Typography
                  style={{
                    color:
                      parseInt(item.schedule_status) === 1 ? "green" : "blue",
                    fontWeight: "bold",
                  }}
                >
                  {parseInt(item.schedule_status) === 1 ? "Active" : "Rest"}
                </Typography>

                {parseInt(item.schedule_status) === 1 && (
                  <>
                    <Typography>
                      {moment(item.start_datetime, "HH:mm").format("hh:mm A")}
                    </Typography>
                    <Typography>-</Typography>
                    <Typography>
                      {moment(item.end_datetime, "HH:mm").format("hh:mm A")}
                    </Typography>
                  </>
                )}

                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSpecificData(item);
                    setOpenEditSched(true);
                  }}
                  size="small"
                  icon={<EditOutlined />}
                />

                {parseInt(item.schedule_status) === 1 && (
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => {
                      setSpecificData(item);
                      setOpenBrokenTime(true);
                    }}
                    size="small"
                    icon={<PlusCircleOutlined />}
                  />
                )}
              </div>
              {item.brokentime.length > 0 && (
                <div>
                  {item.brokentime.map((data, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 173,
                        // border: "1px solid red",
                        maxWidth: 188,
                        justifyContent: "space-around",
                        marginTop: 5,
                      }}
                    >
                      <Typography>
                        {moment(data.start_datetime, "HH:mm").format("hh:mm A")}
                      </Typography>
                      <Typography>-</Typography>
                      <Typography>
                        {moment(data.end_datetime, "HH:mm").format("hh:mm A")}
                      </Typography>
                      <Button
                        type="dashed"
                        shape="circle"
                        onClick={() => {
                          setSpecificData(data);
                          setDeleteDialog(true);
                        }}
                        size="small"
                        icon={<DeleteOutlined />}
                      />
                    </div>
                  ))}
                </div>
              )}
              <Divider />
            </div>
          ))}
        </>
      ) : (
        <>
          {dataSets.map((data, index) => (
            <div key={index}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 80 }}>
                  <Typography>{data.day}</Typography>
                </div>
                <Switch
                  onChange={(e) =>
                    setDataSets(updateStatusByID(data.id, e, dataSets))
                  }
                  checked={data.is_active}
                  size="small"
                />
                <Typography
                  style={{
                    color: data.is_active ? "green" : "blue",
                    fontWeight: "bold",
                  }}
                >
                  {data.is_active ? "Active" : "Rest"}
                </Typography>

                {data.is_active && (
                  <>
                    <TimePicker
                      format={"HH:mm"}
                      onChange={(value, dateString) => {
                        var date = `2023-11-23 ${dateString}:00`;
                        var finalDate = moment(
                          `${date.replace(" ", "T")}.000000Z`
                        )
                          .utc()
                          .format("HH:mm:ss");
                        setDataSets(
                          updateDateByID(data.id, finalDate, dataSets, "in")
                        );
                      }}
                      size="large"
                      required
                      clearIcon={false}
                    />
                    <Typography>-</Typography>
                    <TimePicker
                      format={"HH:mm"}
                      onChange={(value, dateString) => {
                        var date = `2023-11-23 ${dateString}:00`;
                        var finalDate = moment(
                          `${date.replace(" ", "T")}.000000Z`
                        )
                          .utc()
                          .format("HH:mm:ss");
                        setDataSets(
                          updateDateByID(data.id, finalDate, dataSets, "out")
                        );
                      }}
                      size="large"
                      required
                      clearIcon={false}
                    />
                  </>
                )}
              </div>
              <Divider />
            </div>
          ))}

          <Button
            type="primary"
            style={{ width: "100%", borderRadius: "20px" }}
            disabled={!detectIfEmpty}
            onClick={handleCreateEmployeeSchedule}
          >
            Save
          </Button>
        </>
      )}

      {openEditSched && (
        <EditSchedule
          open={openEditSched}
          close={() => setOpenEditSched(false)}
          rerun={() => getEmployeeSchedule()}
          specificData={specificData}
        />
      )}

      {openBrokenTime && (
        <SetBrokenTime
          open={openBrokenTime}
          close={() => setOpenBrokenTime(false)}
          rerun={() => getEmployeeSchedule()}
          specificData={specificData}
        />
      )}

      <Modal
        title="Delete this broken time?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </Drawer>
  );
};

export default SetSchedule;
